import { FastifyPluginAsync } from 'fastify';
import { notificationsRoutes } from './notifications.routes.js';

/**
 * Notifications module
 * Handles notification delivery and management
 */
export const notificationsModule: FastifyPluginAsync = async (fastify) => {
  // Register routes
  await fastify.register(notificationsRoutes, {
    // Keep prefix empty because the module is already mounted at /api/notifications
    prefix: ''
  });
};
